import {IBreakdown, IOption, InsightsContentType, NumberDirection, IDirectionStats, ISearchFilter } from  '@/interfaces/insightsp2';
import { Truncate } from './Text';
import { BuildPath } from './Paths';
import { IContentTable } from  '@/interfaces/IContentTable';
import { Row } from 'react-bootstrap';
import { removeTimeZone } from './Dates';

function breakDownConvert(apiData:any){
 
    const breakdownStructure:IBreakdown[] = [
        {
            image: `${BuildPath()}/images/insightsp2/Likes.svg`,
            number:0,
            label:"Likes",
            ref:"likes",
            contentType: InsightsContentType.Like
        },
        {
            image: `${BuildPath()}/images/insightsp2/Comments.svg`,
            number:0,
            label:"Comments",
            ref:"comments",
            contentType:InsightsContentType.Comment
        },
        {
            image: `${BuildPath()}/images/insightsp2/Audience.svg`,
            number:0,
            label:"Content Views",
            ref:"contentViews",
            contentType:InsightsContentType.View
        },
        {
            image: `${BuildPath()}/images/insightsp2/UniqueViews.svg`,
            number:0,
            label:"Unique Content Views",
            ref:"uniqueContentviews",
            contentType:InsightsContentType.UniqueView
        },
        {
            image: `${BuildPath()}/images/insightsp2/SharedPost.svg`,
            number:0,
            label:"Shared Post Views",
            ref:"sharedPostviews",
            contentType:InsightsContentType.Share
        },
        {
            image: `${BuildPath()}/images/insightsp2/PeopleThanked.svg`,
            number:0,
            label:"People Thanked",
            ref:"peopleThanked",
            contentType:InsightsContentType.Recognition
        },
        {
            image: `${BuildPath()}/images/insightsp2/ugc.svg`,
            number:0,
            label:"UGC Posts",
            ref:"ugcPosts",
            contentType:InsightsContentType.Ugc
        },
        {
            image: `${BuildPath()}/images/insightsp2/FileDownloads.svg`,
            number:0,
            label:"File Downloads",
            ref:"fileDownloads",
            contentType:InsightsContentType.File
        },
        {
            image: `${BuildPath()}/images/insightsp2/VideoPlays.svg`,
            number:0,
            label:"Video Plays",
            ref:"videoPlays",
            contentType:InsightsContentType.Video
        },
        {
            image: `${BuildPath()}/images/insightsp2/MP3Plays.svg`,
            number:0,
            label:"MP3 Plays",
            ref:"mp3Plays",
            contentType: InsightsContentType.Mp3
        },
        {
            image: `${BuildPath()}/images/insightsp2/competitions.svg`,
            number:0,
            label:"Competitions",
            ref:"competitions",
            contentType:InsightsContentType.Competition
        },
        {
            image: `${BuildPath()}/images/insightsp2/compliantposts.svg`,
            number:0,
            label:"Compliance Posts",
            ref:"compliantPosts",
            contentType:InsightsContentType.Compliance
        },
        {
            image: `${BuildPath()}/images/insightsp2/events.svg`,
            number:0,
            label:"Events",
            ref:"events",
            contentType:InsightsContentType.Event
        }
    ]
  
    Object.keys(apiData).map(key => {

        breakdownStructure.map(item => {

            if (item.ref === key){
                item.number = apiData[key];
            }

            return item;
        });

    })

    return breakdownStructure;       
}

function optionsClean(options:IOption[]) {

    let filtered = [...options];

    // Truncate label
    /*
    filtered.forEach(x =>{

        x.label = Truncate(x.label,20)

        return x;
    });
    */

    // Order alpha
    return filtered.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
}

function promiseGen(){

    let resolvePromise;
    const promise = new Promise((resolve) => {
        resolvePromise = resolve;
    });

    return {promise, resolvePromise}

}

function initContentTable():IContentTable  {
    
    return {
        title:"",
        data:[],
        columns:[],
        csvDownload:""
    }
}

function direction(day1No:number, day2No:number) : NumberDirection{
        
    if (day1No === 0 && day2No > 0){
        return NumberDirection.down;
    }

    if (day1No === day2No){
        return NumberDirection.neutral;
    }

    if (day1No > day2No){
        return NumberDirection.up;
    }
    
    if (day1No < day2No){
        return NumberDirection.down;
    }

    return NumberDirection.neutral;
}

function percent(day1No:number, day2No:number) : number{

    let percent;

    // Dans magic Nos
    if (day1No === day2No){
        return -0;
    }

    if (day1No === 0 && day2No > 0){
        return -100;
    }

    if (day2No === 0){
        return 100;
    }

    percent = ( day1No - day2No ) / day2No * 100;

    // Dont floor decimal positve
    if (percent > 0 && percent < 1){
        return 1;
    }

    //return percent.toFixed(2)
    return Math.floor(percent);
}

function addRankings(contentPopDay1:any, contentPopDay2:any) {

    const addRankings = contentPopDay1.map(item=> ({ ...item, id: {directionStats: getDirectionStats(item)} }));

    function getDirectionStats(item:any):IDirectionStats {

        let direction = NumberDirection.na;
 
        // New item
        if(contentPopDay2.filter(x => x.id.directionStats.itemId === item.id).length === 0){
            direction =  NumberDirection.new;
        }
    
        // Indexes
        const day1Idx = contentPopDay1.findIndex(x => x.id === item.id);
        const day2Idx = contentPopDay2.findIndex(x => x.id.directionStats.itemId === item.id);

        if (direction !== NumberDirection.new){

            // Neutral
            if (day1Idx === day2Idx){
                direction = NumberDirection.neutral
            }

            // Ascend
            if (day1Idx < day2Idx){
                direction = NumberDirection.up
            }

            // Descend
            if (day1Idx > day2Idx){
                direction = NumberDirection.down
            }    
        }

        // Date one with rankings
        return {
            leaderBoardPosition:day1Idx+1,
            positionsMoved:day2Idx - day1Idx,
            direction:direction
        }
    }

    return addRankings;
}

function matchColumnOrder(content:IContentTable){

    // This function matches the order in column list with the order in the data set, needed as we have a nested loop to create the table
    // and col order (object.keys) could change by accident or by design in the dataset from API
    function sortObj(obj) {
        return Object.keys(obj)
        .sort((a,b) => {

            const index1 = content.columns.findIndex(x => x.field === a);
            const index2 = content.columns.findIndex(x => x.field === b);

            // Both exist
            if (index1 && index2){

                if (index1 > index2){
                    return 1
                }
                else if (index1 < index2){
                    return -1
                }
            }

            return 0
        })
        .reduce(function (result, key) {
            
            result[key] = obj[key];
            return result;
              
        }, {});
    }

    content.data.forEach((row,idx) => {
        content.data[idx] = sortObj(row)
    });

}

function removeUriNonOrgAdmin_temp(isOrgAdmin:boolean, data:any){

    if (isOrgAdmin) return data;

    return data.map(row => {
        return {
            ...row,
            uri:""
        }
    })

}

function buildCompareDownloadLink(searchFilterOptions:ISearchFilter):string {

    const {date1, date2, selectedWorkspace, selectedUserGroups, existingItem } = searchFilterOptions;

    let query = "";

    // Date 1
    query+= `dateFromFirst=${removeTimeZone(date1.dateFrom)}&dateToFirst=${removeTimeZone(date1.dateTo)}`;

    // Date 2
    query+= `&dateFromSecond=${removeTimeZone(date2.dateFrom)}&dateToSecond=${removeTimeZone(date2.dateTo)}`;

    // Workspace
    if (selectedWorkspace !== null){
        query+= `&workspaceGuids=${selectedWorkspace.value}`
    }

    // Groups
    if (selectedUserGroups.length){    
        selectedUserGroups.forEach((g) => {
            query+= `&userGroupIds=${g.value}`;
        });
    }

    // Content item
    if (existingItem && existingItem.length){
            
        existingItem.forEach((item, idx) => {
            query += `&contentId[${idx}]=${item.id}`
        })
    }
    
    return query;
}

export {breakDownConvert, optionsClean, promiseGen, initContentTable, direction, percent, addRankings, matchColumnOrder, buildCompareDownloadLink}